export const REPLACE_CREDIT_CARD_MODAL_NAME = 'REPLACE_CREDIT_CARD_MODAL_NAME';
